import { formatNumber } from '@angular/common'
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
} from '@angular/core'
import { Map, isImmutable, List, fromJS, isMap, isList } from 'immutable'

@Component({
  selector: 'form-preview-element',
  templateUrl: './form-preview-element.component.html',
  styleUrls: ['./form-preview-element.component.css'],
})
export class FormPreviewElementComponent implements OnInit, OnChanges {
  @Input() public row: Map<string, any>
  @Input() public values: any
  @Input() public activeForm: List<Map<string, any>>
  @Input() public isReadonly = false
  @Input() public isVertical = false
  @Output() onSelect: EventEmitter<any> = new EventEmitter()
  @Output() onSelectInput: EventEmitter<any> = new EventEmitter()
  @Output() onInput: EventEmitter<any> = new EventEmitter()
  public isImmutable = isImmutable
  public value: any
  public previewValue: any = {}
  public options: []
  public percentage: number
  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.values !== undefined) {
      if (this.row.get('isMultiple') && !this.row.get('isPropertyType')) {
        this.value = this.values.get(this.row.get('name'))
          ? this.values
              .get(this.row.get('name'))
              .split(',')
              .map((v: string) => v.trim())
          : []
      } else {
        this.value = this.values.get(this.row.get('name')) || null
      }

      if (this.row.get('options')) {
        this.options = this.row
          .get('options')
          .map((o: any) => o.get('label'))
          .toJS()
      }

      this.percentage = this.getValuePercentage(
        this.row.get('name'),
        this.value,
      )
    } else {
      this.options = this.row.get('options')
      this.percentage = 0
    }
  }

  handleSelectChange({ option, name }) {
    if (!(this.value !== undefined)) {
      if (
        this.row.get('name') === name &&
        !this.row.get('isMultiple') &&
        this.row.get('isPropertyType')
      ) {
        this.previewValue[name] = { [option.get('label')]: '' }
      } else {
        this.previewValue[name] = option
      }

      if (this.row) {
        if (isMap(option)) {
          this.percentage = this.getValuePercentage(
            this.row.get('name'),
            option.get('label'),
          )
        } else if (Array.isArray(option)) {
          console.log('aqqqq')
          const result = option.reduce(
            (total: number, current: Map<string, any>) => {
              return (
                total *
                (this.getValuePercentage(
                  this.row.get('name'),
                  current.get('label'),
                ) /
                  100 +
                  1)
              )
            },
            1,
          )

          console.log('result', result)

          this.percentage = parseFloat(
            formatNumber((result - 1) * 100, 'en', '1.2-2'),
          )
        }
      }
    } else {
      if (
        this.row.get('name') === name &&
        !this.row.get('isMultiple') &&
        this.row.get('isPropertyType')
      ) {
        this.onSelect.emit({
          option:
            option === undefined
              ? null
              : fromJS([
                  {
                    label: option,
                    value: this.getSingleFloors(this.value),
                  },
                ]),
          name,
        })
      } else {
        this.onSelect.emit({
          option: option === undefined ? null : option,
          name,
        })
      }
    }
  }

  public getSingleValue(value: any) {
    if (typeof value === 'string') {
      return ''
    }
    const plainObject = value?.toJS() ?? {}

    return Object.keys(plainObject)?.[0] ?? ''
  }

  getSingleFloors(value: any) {
    if (typeof value === 'string') {
      return ''
    }
    const plainObject = value?.toJS() ?? {}

    return Object.values(plainObject)?.[0] ?? ''
  }

  public getValuePercentage(name: string, value: any) {
    const getFormElementByName = (
      name: string,
      nodes: List<Map<string, any>>,
    ): any => {
      let element: Map<string, any>

      nodes.forEach((elem: Map<string, any>) => {
        if (element === undefined) {
          if (elem.get('name') === name) {
            element = elem
          } else {
            elem.get('options').forEach((option: Map<string, any>) => {
              if (element === undefined) {
                element = getFormElementByName(name, option.get('children'))
              }
            })
          }
        }
      })

      return element
    }
    const getVOptionValue = (name: string, value: any): number => {
      const element = getFormElementByName(name, this.activeForm)
      if (value !== null) {
        if (element.get('type') === 'select' && !element.get('isMultiple')) {
          const option = element
            .get('options')
            .filter(
              (opt: Map<string, any>) =>
                opt.get('label') === (value.trim ? value.trim() : value),
            )
            .get(0)
          return option ? parseFloat(option.get('value')) : 0
        } else if (
          element.get('type') === 'select' &&
          element.get('isMultiple')
        ) {
          const options = element
            .get('options')
            .filter((opt: Map<string, any>) =>
              value ? value.includes(opt.get('label')) : false,
            )
          const totalValue = options.reduce(
            (total: number, current: Map<string, any>) =>
              total * (parseFloat(current.get('value')) / 100 + 1),
            1,
          )

          return parseFloat(formatNumber((totalValue - 1) * 100, 'en', '1.2-2'))
        }
      }
      return 0
    }
    const getElements = (nodes: List<Map<string, any>>) => {
      let percentage: number
      nodes.forEach((node) => {
        if (percentage === undefined) {
          if (node.get('name') === name) {
            percentage = getVOptionValue(name, value)
          } else {
            node.get('options').forEach((option: Map<string, any>) => {
              if (percentage === undefined) {
                percentage = getElements(option.get('children'))
              }
            })
          }
        }
      })
      return percentage
    }
    return getElements(this.activeForm)
  }

  handleSelectInput({ input: { index, value, label }, name }) {
    console.log({ input: { index, value, label }, name })
    if (!(this.value !== undefined)) {
      if (!this.previewValue[name]) {
        this.previewValue[name] = []
      }
      this.previewValue[name][index] = {
        ...this.previewValue[name][index],
        percentage: value,
      }
    } else {
      this.onSelectInput.emit({ input: { index, value, label }, name })
    }
  }

  handleFieldChange(e) {
    if (this.value !== undefined) {
      this.onInput.emit(e)
    } else {
      this.previewValue[e.target.name] = e.target.value
    }
  }

  get previewState() {
    return fromJS(this.previewValue)
  }

  get propertyTypeReadonly() {
    const value = this.value?.toJS()
    const propertyTypes = Object.keys(value)?.map((typeKey: string) => {
      return {
        label: typeKey,
        floors: value[typeKey],
      }
    })

    return propertyTypes
  }

  childrenReadonly(type: string) {
    const form = this.activeForm.toJS()
    const propertyTypeOptions = form.find(
      ({ isPropertyType }) => isPropertyType,
    )?.options
    const option = propertyTypeOptions?.find(({ label }) => label === type)
    const children = option?.children?.map(({ label, name, options }) => ({
      label,
      value: this.values.get(name),
      percentage: options?.find(
        ({ label: opLabel }) => this.values.get(name) === opLabel,
      )?.value,
    }))

    return children
  }

  showChildren(row: any, option: any) {
    if (Map.isMap(option)) {
      return (option.get('children') as any).size > 0
    }
    return false
  }

  get getSelectedOption() {
    return this.row.get('options').find((opt: any) => {
      return (
        opt.get('label') ===
        this.getSingleValue(
          this.value ?? fromJS(this.previewValue[this.row.get('name')]),
        )
      )
    })
  }
}
